export const navLinks = [
  { label: '人物档案', href: '#profile' },
  { label: '动态时间线', href: '#timeline' },
  { label: '账号动向', href: '#accounts' },
  { label: '图集', href: '#photos' },
  { label: '热度数据', href: '#trending' },
  { label: '常见问答', href: '#faq' },
];

export const profileFields = [
  { key: '网络昵称', value: '吃瓜捷克', note: '' },
  { key: '内容身份', value: '热点解说型创作者，做娱乐资讯整理与吃瓜复盘', note: '公开标签' },
  { key: '活跃平台', value: '微博 · 抖音 · 视频号', note: '多端同步' },
  { key: '首次活跃', value: '约 2021 年进入公开视野', note: '据评论区考古' },
  { key: '年龄线索', value: '公开资料较少，普遍猜测 25–29 岁区间', note: '未经本人官方确认' },
  { key: '内容方向', value: '娱乐圈资讯、事件前因后果梳理、热梗速递', note: '以合集/长视频为主' },
  { key: '更新频率', value: '不定期更新，热点事件后常在 24 小时内复盘', note: '不稳定但及时' },
];

export const timelineItems = [
  {
    date: '2026.08',
    tag: '近期',
    tagType: 'accent',
    title: '多个账号仍在同步运营',
    text: '热点事件后按惯例发布复盘内容，评论区依旧活跃，粉丝追问「这次到底什么情况」成为固定互动。',
  },
  {
    date: '2025.11',
    tag: '数据',
    title: '长视频复盘冲上平台热榜',
    text: '一条「一口气讲清事件前因后果」的合集登上热搜相关内容，单日涨粉显著，也让更多路人开始搜「吃瓜捷克是谁」。',
  },
  {
    date: '2024.04',
    tag: '直播',
    title: '不定期直播连麦答疑',
    text: '直播以「不讲废话、只给结论」的节奏被网友整理成金句合集，相关片段在站内被反复转发。',
  },
  {
    date: '2023.05',
    tag: '澄清',
    title: '针对流传身份信息公开回应',
    text: '针对网上流传的年龄与身份猜测，本人曾在动态中提醒「网上信息参差，以本人账号为准」，本页据此标注重心也放在官方账号上。',
  },
  {
    date: '2022.01',
    tag: '破圈',
    title: '一条合集视频迎来涨粉节点',
    text: '用高信息密度的方式讲清一桩圈内事件，语速与梗密度成为记忆点，账号进入更多人的「关注与取关反复拉扯」清单。',
  },
  {
    date: '2021.03',
    tag: '起源',
    title: '因评论区犀利回复被截图搬运',
    text: '一段评论区「一句话拆穿套路」的回复被大量截图搬运，人物开始从「会说话的网友」进入大众吃瓜视野。',
  },
];

export const accountList = [
  {
    platform: '微博',
    handle: '@吃瓜捷克',
    icon: 'ri-weibo-line',
    tone: 'text-primary-700 bg-primary-100',
    verified: '娱乐博主 · 已认证',
    followers: '126.8万',
    posts: 382,
    update: '约 3 天前',
    lastPost: '这波反转，其实早有铺垫，一句话讲清楚。',
    desc: '适合追文字长评与即时表态，评论区信息密度高，也是许多截图的第一来源地。',
    actions: ['关注账号', '看他近况'],
  },
  {
    platform: '抖音',
    handle: '@吃瓜捷克',
    icon: 'ri-music-2-line',
    tone: 'text-foreground-800 bg-foreground-100',
    verified: '内容创作者 · 已认证',
    followers: '340.2万',
    posts: 516,
    update: '约 5 小时前',
    lastPost: '合集更新：这一期把来龙去脉一次性讲完。',
    desc: '以合集与长视频复盘为主，适合视频倍速党，评论区「催更」声最高的一处阵地。',
    actions: ['关注账号', '看最新视频'],
  },
];

export const trendingItems = [
  { rank: 1, keyword: '吃瓜捷克是谁', heat: 100, delta: '持平' },
  { rank: 2, keyword: '吃瓜捷克年龄', heat: 86, delta: '上升' },
  { rank: 3, keyword: '吃瓜捷克个人资料', heat: 78, delta: '上升' },
  { rank: 4, keyword: '吃瓜捷克照片', heat: 66, delta: '下降' },
  { rank: 5, keyword: '吃瓜捷克微博', heat: 58, delta: '持平' },
  { rank: 6, keyword: '吃瓜捷克抖音', heat: 51, delta: '上升' },
];

export const faqItems = [
  {
    q: '吃瓜捷克到底是谁？是真实存在的人吗？',
    a: '从公开动态看，吃瓜捷克是一名围绕娱乐与热点做内容复盘的网络创作者，有真实在更新的账号与作品。至于其背后是否为单人运营，本人从未公开说明，本页不做断言，仅整理可被公开查证的网络踪迹。',
  },
  {
    q: '网上流传的「年龄」是怎么得出的？可靠吗？',
    a: '目前公开资料很少，年龄基本是网友依据其内容里出现的细节、说话风格与早期动态时间倒推出来的猜测，普遍落在 25–29 岁区间，属于「疑似」而非「实锤」。任何带精确数字的「官方年龄」都要警惕，更可能是营销号编的。',
  },
  {
    q: '为什么有人在微博 / 抖音搜不到本人账号？',
    a: '搜索同名账号容易混进仿冒号。建议认准「已认证」标识，并优先点开其历史作品与关注列表核对内容风格；吃瓜捷克本人账号都以同名且配了认证信息，出现在顶部的多半才是本人。',
  },
  {
    q: '网上的「吃瓜捷克照片」是真的吗？',
    a: '互联网上流传的多为其视频封面、直播切片或截图，公开真人照片极少且无法核实真伪。见到「独家高清素颜照」这类说法时基本可直接视为流量噱头，别当真也别传播。',
  },
  {
    q: '出现好多同名账号，怎么分辨真假？',
    a: '一看出没认证，二看内容是否长期稳定更新并互相关联，三看是否频繁引导到外链或私聊。只发搬运、只挂交友信息、简介花哨的多半是蹭流量仿冒号。',
  },
  {
    q: '我手上资料有误，或发现了新线索，该怎么办？',
    a: '你可以在下方「提交纠错」填写补充信息，我们每周会核对公开动态后统一更新。所有结论都会标注来源性质（认证动态 / 网友推测 / 未核实），请勿把推测当事实传播。',
  },
];

export const galleryItems = [
  {
    src: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20online%20content%20creator%20casual%20smart%20casual%20shirt%2C%20standing%20in%20a%20warm%20minimal%20studio%20with%20soft%20cream%20and%20coral%20backdrop%2C%20soft%20key%20lighting%2C%20editorial%20portrait%20photography%2C%20subtle%20smile%2C%20clean%20commercial%20aesthetic%2C%20high%20detail%2C%20shallow%20depth%20of%20field&width=900&height=1200&seq=portrait-main-01&orientation=portrait',
    caption: '主档案肖像 · 公开动态常用风格',
    w: 'portrait',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20of%20a%20young%20Chinese%20video%20creator%20recording%20at%20a%20clean%20desk%20with%20laptop%20and%20ring%20light%2C%20warm%20minimal%20room%20in%20cream%20and%20soft%20orange%20tones%2C%20editorial%20documentary%20photography%2C%20natural%20soft%20light%2C%20candid%20atmosphere%2C%20high%20detail%2C%20cohesive%20color%20palette&width=1200&height=800&seq=scene-desk-01&orientation=landscape',
    caption: '录制幕后 · 日常更新场景',
    w: 'landscape',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20young%20Chinese%20creator%20speaking%20expressively%20to%20camera%20with%20gestures%2C%20warm%20minimal%20studio%20lighting%2C%20cream%20and%20coral%20background%2C%20editorial%20interview%20photography%2C%20high%20detail%2C%20sharp%20focus%20on%20face%2C%20cohesive%20warm%20palette&width=900&height=900&seq=scene-talking-01&orientation=squarish',
    caption: '盘点视频 · 表情切片',
    w: 'squarish',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=young%20Chinese%20streamer%20sitting%20in%20front%20of%20a%20softly%20lit%20monitor%20with%20microphone%20during%20a%20casual%20live%20session%2C%20warm%20neutral%20room%20tones%20of%20cream%20and%20warm%20orange%2C%20documentary%20style%2C%20natural%20ambient%20light%2C%20editorial%20photography%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=1200&height=800&seq=scene-live-01&orientation=landscape',
    caption: '直播切片 · 只给结论的风格',
    w: 'landscape',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=young%20Chinese%20creator%20holding%20smartphone%20and%20reading%20comments%20with%20a%20focused%20expression%2C%20warm%20minimal%20coffee%20shop%20setting%20with%20cream%20and%20amber%20tones%2C%20editorial%20portrait%20photography%2C%20soft%20window%20light%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=900&height=1200&seq=scene-phone-01&orientation=portrait',
    caption: '评论区互动 · 金句出处',
    w: 'portrait',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=creative%20flat%20lay%20of%20notebook%20laptop%20and%20warm%20props%20on%20a%20desk%20representing%20content%20planning%20for%20an%20entertainment%20recap%20channel%2C%20cream%20and%20coral%20tones%2C%20minimal%20editorial%20product%20photography%2C%20soft%20shadows%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=900&height=900&seq=scene-outline-01&orientation=squarish',
    caption: '选题筹备 · 一次讲清的背后',
    w: 'squarish',
  },
];

export const heroChips = [
  '吃瓜捷克是谁',
  '吃瓜捷克年龄',
  '吃瓜捷克个人资料',
  '吃瓜捷克微博',
  '吃瓜捷克抖音',
];